import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { useDispatch, useSelector } from 'react-redux';
import { authTokenSelector } from '../../selectors/userSelectors';
import { getFeatureSettings } from '../../actions/orderActions';
import { Tooltip } from 'antd';
import { MdInfoOutline } from 'react-icons/md';
import styles from '../BundleDetailsEmailInfo/BundleDetailsEmailInfo.module.scss';
import { FeatureSetting } from '../../types/featureSettings.types';

interface DomainFeatureSettingsProps {
  mailOrderId: number;
}

const DomainFeatureSettings = ({ mailOrderId }: DomainFeatureSettingsProps) => {
  const dispatch = useDispatch();
  const token = useSelector(authTokenSelector);
  const [features, setFeatures] = useState<Record<string, FeatureSetting> | null>(null);

  useEffect(() => {
    if (!mailOrderId) return;
    const fetch = async () => {
      try {
        const res: any = await dispatch(getFeatureSettings(mailOrderId, undefined, token));
        setFeatures(res?.featureSettings ?? null);
      } catch {
        setFeatures(null);
      }
    };
    fetch();
  }, [mailOrderId]);

  if (!features) return null;

  const visibleFeatures = Object.entries(features)
    .filter(([, f]) => !f.hideFeature)
    .sort(([, a], [, b]) => a.displayOrder - b.displayOrder);

  if (!visibleFeatures.length) return null;

  return (
    <div className={styles.emailInfoWrapper}>
      <div className={`${styles.section} ${styles.sectionNoTopMargin}`}>
        <div className={styles.sectionHeading}>
          <span><FormattedMessage id="feature-settings-heading" /></span>
          <Tooltip
            placement="right"
            title={
              <div>
                <div><FormattedMessage id="feature-settings-order-tooltip-info" /></div>
                <br />
                <div><span className={styles.featureSubscribedTooltip}><FormattedMessage id="feature-settings-subscribed" /></span> — <FormattedMessage id="feature-settings-subscribed-info" /></div>
                <div><span className={styles.featureNotSubscribedTooltip}><FormattedMessage id="feature-settings-not-subscribed" /></span> — <FormattedMessage id="feature-settings-not-subscribed-info" /></div>
              </div>
            }
          >
            <span className={styles.featureTooltipIcon}>
              {(MdInfoOutline as any)({ className: 'tooltip-icon' })}
            </span>
          </Tooltip>
        </div>
        <div className={styles.sectionData}>
          <ul className="list-unstyled">
            {visibleFeatures.map(([name, f]) => (
              <li key={name}>
                {name}:{' '}
                {f.subscribed ? (
                  <span className={styles.featureSubscribed}>
                    <FormattedMessage id="feature-settings-subscribed" />{f.subscriptionType ? ` (${f.subscriptionType})` : ''}
                  </span>
                ) : f.trialAvailable ? (
                  <span><FormattedMessage id="feature-settings-trial-available" /></span>
                ) : (
                  <span className={styles.featureNotSubscribed}><FormattedMessage id="feature-settings-not-subscribed" /></span>
                )}
              </li>
            ))}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default DomainFeatureSettings;
